module.exports = __webpack_public_path__ + "static/media/alert-info.8623b4db.svg";